import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/category/all?q=${encodeURIComponent(searchTerm.trim())}`);
    }
  };

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20warm%20orange%20and%20deep%20charcoal%20gradient%20overlay%2C%20soft%20out%20of%20focus%20bokeh%20lights%2C%20luxurious%20theater%20ambient%20atmosphere%2C%20elegant%20modern%20design%2C%20no%20text%20no%20people&width=1920&height=800&seq=hero-bg-orange-video&orientation=landscape"
        alt="桔子视频背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl font-bold font-heading text-white mb-4 leading-tight">
            高清视频，流畅不缓冲
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
            收录91视频网站、久久视频等热门资源，91在线视频高清免费观看，菠萝视频同步更新
          </p>

          <form onSubmit={handleSearch} className="max-w-xl mx-auto">
            <div className="flex items-center bg-white/15 backdrop-blur-md rounded-full p-1.5 border border-white/20">
              <div className="flex-1 flex items-center px-3">
                <i className="ri-search-line text-white/60 text-lg"></i>
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="搜索你喜欢的视频、电视剧、电影..."
                  className="flex-1 bg-transparent border-none outline-none text-white placeholder-white/40 px-3 py-2 text-sm"
                />
              </div>
              <button
                type="submit"
                className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm whitespace-nowrap transition-all duration-200 cursor-pointer"
              >
                <i className="ri-search-line mr-1.5"></i>
                搜索
              </button>
            </div>
          </form>

          <div className="flex items-center justify-center gap-4 mt-6 flex-wrap">
            <span className="text-sm text-white/50">热门搜索:</span>
            {['狂飙', '流浪地球2', '斗罗大陆', '三体', '长风渡'].map((term) => (
              <button
                key={term}
                onClick={() => {
                  setSearchTerm(term);
                  navigate(`/category/all?q=${encodeURIComponent(term)}`);
                }}
                className="text-sm text-white/70 hover:text-white bg-white/10 hover:bg-white/20 px-3 py-1 rounded-full transition-all cursor-pointer whitespace-nowrap"
              >
                {term}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}